import Phaser from "phaser";
import LevelBase from "./levelBase";
import { Enemy, NPCharacter, Player } from "../objects";
import { Interactive } from "../objects";
import { translate } from "../../utils/localization";

class Level5 extends LevelBase {
  constructor() {
    super();
    this.name = "The encounter";
    this.enemiesDeadCount = 0;
  }

  get id() {
    return this.constructor.key
  }

  async connectToScene(scene) {
    await super.connectToScene(scene);
    
    // removes dwarf if level was finished in the past
    if (!this.unfinished) {
      this.leader.alien.alpha = 0
      this.replaceByEmpty(this.leader)
    }
  }
  destroy() {
    // this.scene.events.off('update', this.updateLight.bind(this))
  }

  updateLight() {
    const layer = this.scene.children.getByName("layer_1");
    if (!layer) {
      return true;
    }
    const map = layer.tilemap;
    let origin = this.player.position;
    this.moveables.forEach((el) => {
      var dist = Phaser.Math.Distance.Snake(
        origin.x,
        origin.y,
        el.position.x,
        el.position.y
      );

      el.alien?.setAlpha(1 - 0.1 * dist);
    });
    map.forEachTile((tile) => {
      var dist = Phaser.Math.Distance.Snake(origin.x, origin.y, tile.x, tile.y);

      tile.setAlpha(1 - 0.1 * dist);
    });
  }

  onInteractWith(el) {
    if (el.order === 0) {
      this.onComplete();
    }
  }
  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }
    if (el.isClass(NPCharacter)) {
      el.leadingPath = [
        { x: 8, y: 36 },
        { x: 9, y: 36 },
        { x: 10, y: 36 },
        { x: 11, y: 36 },
        { x: 11, y: 37 },
        { x: 11, y: 38 },
        { x: 11, y: 39 },
        { x: 11, y: 40 },
        { x: 12, y: 40 },
        { x: 13, y: 40 },
        { x: 14, y: 40 },
        { x: 14, y: 39 },
        { x: 14, y: 38 },
        { x: 15, y: 38 },
        { x: 16, y: 38 },
        { x: 17, y: 38 },
        { x: 18, y: 38 },
        { x: 19, y: 38 },
        { x: 20, y: 38 },
        { x: 21, y: 38 },
        { x: 22, y: 38 },
        { x: 23, y: 38 },
        { x: 24, y: 38 },
        { x: 25, y: 38 },
        { x: 26, y: 38 },
        { x: 27, y: 38 },
        { x: 28, y: 38 },
        { x: 29, y: 38 },
        { x: 30, y: 38 },
      ];
      el.isCloseEnough = () => this.dwarfRun;
    }
  }

  onCharacterDie(el) {
    super.onCharacterDie(el);
    if (el.isClass(Enemy)) {
      this.enemiesDeadCount++;

      if (this.enemiesDeadCount === 1 && this.unfinished) {
        // disconnect user
        this.player.disconnect();
      }
      if (this.enemiesDeadCount === 2 && this.unfinished) {
        // after killing the second enemy
        this.encounter();
      }
    }
  }

  encounter() {
    // move npc
    this.dwarfRun = true;
    this.onNextTick(this.moveDwarf.bind(this));
    // show dialog
  }

  moveDwarf() {
    // hack to auto move dwarf until pos x is 10
    if (this.dwarfRun) {
      if (this.leader.position.x < 11) {
        this.leader.onPlayerMoves(this.player.position);
        this.onNextTick(this.moveDwarf.bind(this));
      } else {
        if (!this.leader.alien.anims.currentAnim.key.includes("idle")) {
          this.leader?.animIdle();
        }
        this.player.reconnect();
        this.showDialog1();
      }
    }
  }

  showDialog1() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Dwarf", "closeUp_Mary"],
      participantNames: ["???", "Mary"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_5.dialog_1.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_5.dialog_1.dwarf_say_1")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_5.dialog_1.mary_say_2")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_5.dialog_1.dwarf_say_2")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_5.dialog_1.mary_say_3")],
        },
      ],
    });
  }
}

Level5.key = "level_5";
export default Level5;
